import CIMSFormItem from 'components/CIMSFormItem'
import { CIMSModal } from 'components/CIMSModal'
import UserSelect from 'components/CIMSSelect/common/UserSelect'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { useEditWorkflowPermissionMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { HelpMessage } from 'utils/constants'
import { usePermissionsContext } from '../../../PermissionsContext'
import { buildEditPermissionInputFromRecord } from '../../../utils'
import { AddUsersFormValues } from '../../../types'

function AddUsersModal() {
  const {
    modals: {
      addUsers: { toggle, visible },
    },
    refetch,
    selection: { records: selectedPermissions, setRowKeys },
  } = usePermissionsContext()
  const [editPermission, { loading: editing }] =
    useEditWorkflowPermissionMutation(DefaultMutationHookOptions)

  async function bulkAddUsers({ users }: AddUsersFormValues) {
    const userIds = users.map(({ value }) => value.toString())
    const updates: ReturnType<typeof editPermission>[] = []

    selectedPermissions.forEach((permission) => {
      const existingUsers = new Set(permission.users)
      const usersToAdd = userIds.filter((id) => {
        if (existingUsers.has(id)) return false
        existingUsers.add(id)
        return true
      })
      if (!usersToAdd.length) return
      updates.push(
        editPermission({
          variables: {
            input: buildEditPermissionInputFromRecord(permission, [
              ...permission.users,
              ...usersToAdd,
            ]),
          },
        })
      )
    })

    if (updates.length) {
      await Promise.all(updates)
      await refetch()
      simpleEditNotification('Permissions')
    }
    setRowKeys([])
    toggle(null)
  }

  return (
    <CIMSModal<AddUsersFormValues>
      visible={visible}
      title="Add users"
      onCancel={() => toggle(null)}
      loading={editing}
      disabled={editing}
      onOk={bulkAddUsers}
    >
      <CIMSFormItem
        name="users"
        label="Users"
        help={HelpMessage.CustomWorkflows.Permissions.AddUsers}
        requiredMessage="Please select at least one user"
      >
        <UserSelect mode="multiple" style={{ width: '100%' }} />
      </CIMSFormItem>
    </CIMSModal>
  )
}

export default AddUsersModal
